import React, {useEffect, useRef, useState} from 'react'
import FailedModal from "../../CustomModal/Failed";
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import Header from "../../layout/header";
import {toast} from "react-toastify";
import SuccessModal from "../../CustomModal/Success";
import distanceBetweenTwoPoints from "../../DistanceBetweenTwoPoints";
import DistanceCalculatorV2 from "../../DistanceCalculatorV2";
import {generateRandomString, versionCheck} from "../../Common";
import useSiteDistance from "../../../hooks/currentlocation/useSiteDistance";
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import useLatLng from "../../../hooks/uselatlng/uselatlng";

const FastTagTollActivitySave = ({
                                     documentUploadUrlPublic,
                                     documentUrlDataPublic = [],
                                     history,
                                     match,
                                     getActivity,
                                     types = [],
                                     senior = [],
                                     getSenior,
                                     activitySave,
                                     saveActivityResponse = [],
                                     isCheckout,
                                     isCheckoutDetails = [],
                                     getPendingActivity,
                                     pendingActivity=[],
                                     markAttendance,
                                     attendance=[],
                                     tollById,
                                     tollView=[],
                                     getFse,
                                     fseDetails=[],
                                     errorLogs
                                 }) => {
    var now = new Date();
    var min = new Date()
    now.setDate(now.getDate()+1)
    min.setDate(min.getDate()+1)
    min.setMinutes(min.getMinutes() - min.getTimezoneOffset());
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const currentUserLocation = useRef(null);
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        meta_data: {},
        lat: '',
        long: '',
        next_activity_type_id: '',
        next_activity_date: '',
        description: '',
        tagged_along: '',
        account_id:'',
        reason:[]
    }])
    const [isActivityCreated, setIsActivityCreated] = useState(false)
    const [checkInText, setCheckInText] = useState('')
    const [activityTypeId, setActivityTypeId] = useState('')
    const [distance, setDistance] = useState(0)
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({})
    const [successMessage, setSuccessMessage] = useState('')
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [openCheckIn, setOpenCheckIn] = useState(false)
    const [reason, setReason] = useState([{}])
    const [FSE, setFSE] = useState([{name:'', description:'', selfie:''}])
    const [clientName, setClientName] = useState('')
    const [deviceId, setDeviceId] = useState('')
    const [isMockLocation, setIsMockLocation] = useState(false)
    const [hideCheckIn, setHideCheckIn] = useState(false);
    const [isLocationFetching, setIsLocationFetching] = useState(false);
    const [locationStatus, setLocationStatus] = useState(null)
    const [appVersion, setAppVersion] = useState(null);
    let siteDistance = useSiteDistance(
        tollView?.data?.latitude,
        tollView?.data?.longitude
    )

    useEffect( async () => {
        const webView = window.localStorage?.webview;
        setAppVersion(window.localStorage?.app_version);
        if(versionCheck('3.0.0')){
            if(webView !== undefined && webView == 'true') {
                setIsLocationFetching(true);
                getUserLocation();
            } else {
                setIsLoading(true);
                setLocationStatus('granted');
                currentUserLocation.current = await getLocation();
                console.log("currentUserLocation.current", currentUserLocation.current)
                setIsLocationFetching(false);
                setIsLoading(false)
            }
        }
    }, []);

    function locationCallback(data) {
        if (data.detail) {
            if (data?.detail?.gps_status === "granted") {
                if (data.detail.status === "granted") {
                    setLocationStatus("granted");
                    currentUserLocation.current = {
                        lat: data?.detail?.latitude,
                        long: data?.detail?.longitude,
                        is_mock: data.detail.mocked,
                        device_id: data.detail.device_id
                    }
                } else {
                    setLocationStatus("permission_denied");
                }
            } else {
                setLocationStatus("gps_denied");
            }
        }
        setIsLocationFetching(false);
    }

    const getUserLocation = () => {
        let eventName = `locationEvent${generateRandomString()}`;
        window.addEventListener(eventName, locationCallback)
        window.ReactNativeWebView.postMessage(JSON.stringify({
            event_name: "get_current_location",
            data: {
                accuracy: 4,
                callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
            }
        }));
        return () => {
            window.removeEventListener(eventName, locationCallback)
        }
    }

    function getLocation() {

        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
                    if (permissionStatus.state === 'denied') {
                        alert('Please allow location access.');
                        setIsLoading(false);
                        reject('Location access denied.');

                    } else {
                        setLocationStatus('granted')
                        navigator.geolocation.getCurrentPosition(
                            (success) => {
                                if (success?.coords && success.coords.latitude) {
                                    const location = {
                                        lat: success.coords.latitude,
                                        long: success.coords.longitude,
                                        is_mock: false,
                                        device_id: ''
                                    };
                                    setIsLoading(false);
                                    resolve(location);
                                }
                            },
                            (error) => {
                                setIsLoading(false);
                                reject(error);
                            }
                        );
                    }
                }).catch(err => {
                    setIsLoading(false);
                    reject(err);
                });
            } else {
                setIsLoading(false);
                reject('Geolocation not supported.');
            }
        });
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getActivity()
            await getPendingActivity(match?.params?.account_id !== undefined ? match?.params?.account_id : '')
            await isCheckout('', match?.params?.account_id)
            await tollById(match?.params?.account_id)
            await getSenior()
            await getFse()
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        let values = ""
        let names = []
        if (taggedAlonedReportee !== [] && taggedAlonedReportee !== '' && taggedAlonedReportee.length > 0) {
            taggedAlonedReportee.map((val, i) => {
                names[i] = val?.name
                if (i === 0) {
                    values = val.id
                } else {
                    values += ',' + val.id
                }
            })
        }
        handleInput('tagged_along', values, '', '');
    }, [taggedAlonedReportee])


    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveActivityResponse?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(saveActivityResponse?.message)
        } else if (saveActivityResponse?.status !== undefined && saveActivityResponse?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(saveActivityResponse?.message)
        }
    }, [saveActivityResponse])

    useEffect(() => {
        if (isCheckoutDetails?.data !== undefined  && Object.keys(isCheckoutDetails?.data).length > 0) {
            setOpenCheckIn(true)
            setCheckInText("Check out")
        }
    }, [isCheckoutDetails, pendingActivity])

    useEffect(() => {

        if(pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0){
            (async () => {
                setIsActivityCreated(true)
                setClientName(pendingActivity?.data?.client_name+"( "+pendingActivity?.data?.fast_tag_toll_no+" )")
                setIsLoading(true)
                await isCheckout(pendingActivity?.data?.id, match?.params?.account_id)
                setIsLoading(false)
            })()
        }
    }, [pendingActivity])
    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if (list['next_activity_type_id'] === '') {
            toast.error("Please choose activity type")
            return false
        }
        list['next_activity_date'] = currentDate
        list['account_id'] = match?.params?.account_id

        if (list['next_activity_date'] === '') {
            toast.error("Please choose next activity date")
            return false
        }

        if(!versionCheck('3.0.0')) {
            list['lat'] = islatlng?.lat
            list['long'] = islatlng?.lng
        } else {
            list['lat'] = currentUserLocation?.current?.lat
            list['long'] = currentUserLocation?.current?.long
        }

        list['reason'] = reason
        reason.map((val)=>{
            if(val?.reason == "FSE"){
                list['fse_details'] = FSE
            }
        })
        
        // if (activityId !== 0) {
        //     list['id'] = activityId
        // }

        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }

        if (isActivityCreated && list['next_activity_type_id'] !== '') {
            toast.error("Please complete your pending activity before creating new one on "+clientName)
            return false
        }
        setIsLoading(true)
        await activitySave(list)
        setIsLoading(false)
    }

    useEffect(() => {
        // after check in hide popup
        if (attendance?.data !== undefined && attendance?.status === 200) {
            toast.success("Attendance is marked successfully")
            setOpenCheckIn(false)

            if(checkInText === "Check out"){
                window.location.href=`fast-tag-toll-activity-list/${match?.params?.account_id}`
            }
        }else{
            toast.warning(attendance?.message)
        }
    }, [attendance, pendingActivity])

    useEffect(() => {
        if (tollView?.data !== undefined && tollView?.data?.longitude !== undefined ) {
            if(versionCheck('3.0.0')){
                let distance = 0;
                if(currentUserLocation?.current?.lat && currentUserLocation?.current?.long){
                    distance = distanceBetweenTwoPoints(tollView?.data?.latitude, currentUserLocation?.current?.lat, tollView?.data?.longitude, currentUserLocation?.current?.long);
                }

                if (currentUserLocation?.current?.device_id) {
                    setDeviceId(currentUserLocation?.current?.device_id)
                } else if (parseInt(window.localStorage.login_preference) === 2) {
                    // check device id is present or not whe user login in app
                    setOpenCheckIn(false);
                    toast.error("Device is missing!");
                }
                setDistance(parseFloat(distance).toFixed(2))

                if(currentUserLocation?.current?.is_mock){
                    setIsMockLocation(true)
                }
                // let distance = calcCrow(tollView?.data?.latitude, tollView?.data?.longitude, islatlng?.lat, islatlng?.lng)

                setTimeout(() => {
                    setIsLoading(true)
                    setIsLoading(false)
                }, 1000)
            }
        }
    }, [tollView, currentUserLocation?.current?.lat])

    useEffect(() => {
        if (tollView?.data !== undefined && tollView?.data?.longitude !== undefined ) {
            if(!versionCheck('3.0.0')) {
                if(siteDistance?.distance_in_km !== undefined && siteDistance?.distance_in_km !== 'NaN'){
                    let distance = siteDistance?.distance_in_km;
                    console.log("toll save distance event response "+ JSON.stringify(siteDistance))
                    if (siteDistance?.device_id) {
                        setDeviceId(siteDistance?.device_id)
                    } else if (parseInt(window.localStorage.login_preference) === 2) {
                        // check device id is present or not whe user login in app
                        setOpenCheckIn(false);
                        toast.error("Device is missing!");
                    }
                    setDistance(parseFloat(distance).toFixed(2))
                }

                if(siteDistance?.is_mock){
                    setIsMockLocation(true)
                }
                // let distance = calcCrow(tollView?.data?.latitude, tollView?.data?.longitude, islatlng?.lat, islatlng?.lng)

                setTimeout(() => {
                    setIsLoading(true)
                    setIsLoading(false)
                }, 1000)
            }
        }
    }, [tollView, siteDistance])

    useEffect(() => {
        if(parseFloat(distance) > 2){
            toast.warning("Your are outside 2km radius of the toll")
        }
    }, [distance])

    const handleAddReason = () => {
        setReason([
            ...reason,
            {reason: ''}
        ])
    }

    const handleRemoveReason = (e, index) => {
        e.preventDefault()
        const list = [...reason]
        list.splice(index, 1);
        setReason(list);
    }

    const handleAddFSE = () => {
        setFSE([
            ...FSE,
            {name:'', description:'', selfie:''}
        ])
    }

    const handleRemoveFSE = (e, index) => {
        e.preventDefault()
        const list = [...FSE]
        list.splice(index, 1);
        setFSE(list);
    }

    const handleReason = (val, i, e) => {
        let list = [...reason]

        let isProduct = false
        reason.map((value, i) => {
            if(value?.reason === val){
                isProduct = true
            }
        })
        if(isProduct){
            handleRemoveReason(e, i)
            toast.warning(val+" already added")
            return false
        }

        list[i]['reason'] = val
        setReason(list)
    }

    const handleFSE = (val, i, e) => {
        let list = [...FSE]

        let isProduct = false
        FSE.map((value, i) => {
            if(value?.name === val){
                isProduct = true
            }
        })
        if(isProduct){
            handleRemoveFSE(e, i)
            toast.warning(val+" already added")
            return false
        }

        list[i]['name'] = val
        setFSE(list)
    }

    useEffect(() => {
        if(isMockLocation){
            setOpenCheckIn(false)
            setHideCheckIn(true)
            // toast.error('Location morphing is cheating. Check out not allowed');
            handleErrorLogsSave(`"Location morphing is cheating. ${checkInText} not allowed"`, checkInText);
            setCountToOpenModal(countToOpenModal+1);
        }
    }, [isMockLocation])

    const handleErrorLogsSave = async (msg, type) => {
        setIsLoading(true)
        await errorLogs({
            module_type:"Fastag Toll",
            message: msg,
            type: type,
            device_id: window.localStorage.device_id ?? null
        })
        setIsLoading(false)
    }

    const refreshUserLocation = async (e) => {
        e.preventDefault();
        const webView = window.localStorage?.webview;
        if(webView !== undefined && webView == 'true') {
            setIsLocationFetching(true);
            getUserLocation();
        } else {
            setIsLoading(true);
            setIsLocationFetching(true);
            currentUserLocation.current = await getLocation();
            setIsLocationFetching(false);
            setIsLoading(false);
        }
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={`fast-tag-toll-activity-list/${match?.params?.account_id}`}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
                // url={backUrl}
            />

            {isMockLocation &&
                <FailedModal
                    isOpen={isMockLocation}
                    msg={`Location morphing is cheating. ${checkInText} not allowed`}
                    countToOpenModal={countToOpenModal}
                    url={`fast-tag-toll-activity-list/${match?.params?.account_id}`}
                />
            }
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {openCheckIn ? <div className="popup-box">
                                    {!versionCheck('3.0.0') ?
                                        <DistanceCalculator
                                            isMapShow={true}
                                            calculateDistance={markAttendance}
                                            moduleType={'Fasttag Toll'}
                                            checkInText={checkInText}
                                            checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                            activityId={isCheckoutDetails?.data?.activity_id !== undefined ? isCheckoutDetails?.data?.activity_id : ""}
                                            accountId={isCheckoutDetails?.data?.account_id !== undefined ? isCheckoutDetails?.data?.account_id : ""}
                                            documentUploadUrlPublic={documentUploadUrlPublic}
                                            documentUrlDataPublic={documentUrlDataPublic}
                                            deviceId={deviceId}
                                            deviceIdCheck={true}
                                            hideCheckButton={hideCheckIn}
                                        /> :
                                        <div className="box">
                                            <DistanceCalculatorV2
                                                isMapShow={true}
                                                calculateDistance={markAttendance}
                                                moduleType={'Fasttag Toll'}
                                                checkInText={checkInText}
                                                checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                                activityId={isCheckoutDetails?.data?.activity_id !== undefined ? isCheckoutDetails?.data?.activity_id : ""}
                                                accountId={isCheckoutDetails?.data?.account_id !== undefined ? isCheckoutDetails?.data?.account_id : ""}
                                                documentUploadUrlPublic={documentUploadUrlPublic}
                                                documentUrlDataPublic={documentUrlDataPublic}
                                                deviceId={deviceId}
                                                deviceIdCheck={true}
                                                hideCheckButton={hideCheckIn}
                                            />
                                        </div>
                                    }
                                </div>
                                :
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                {versionCheck('3.0.0') &&
                                                    <div
                                                        className="d-flex align-items-center justify-content-between com-sub-heading">
                                                        {isLocationFetching ? "Location fetching..." : ""}
                                                        {locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                                            <span
                                                                style={{color: "green"}}
                                                                className="ml-5">{distance + " km away from site"}
                                                            </span> :
                                                            <h1 className="h3 mb-0 text-black-100">
                                                                {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                                                <span
                                                                    style={{color: "green"}}
                                                                    className="ml-5"> You've denied GPS/permission, please allow it and then relaunch the
                                            application</span>
                                                            </h1>
                                                        }
                                                        <button className="btn btn-primary mr-4" onClick={(e) => {
                                                            refreshUserLocation(e)
                                                        }}><i className="bi bi-arrow-clockwise f-20px"></i></button>
                                                    </div>
                                                }
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_type_id', e.target.value, e)
                                                                        setActivityTypeId(e.target.value)
                                                                    }} required>
                                                                    <option value="">Select Activity</option>
                                                                    {types && types?.data !== undefined && types?.data.map((val) => {
                                                                        return (
                                                                            <>
                                                                                <option
                                                                                    value={val?.id}>{val.name}
                                                                                </option>
                                                                            </>
                                                                        )
                                                                })}
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Schedule Activity
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6 mtk-075 float-field">
                                                            <input type="datetime-local"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput('next_activity_date', e.target.value, e)
                                                                       setCurrentDate(e.target.value)
                                                                   }}
                                                                   my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                                                                   id="validationCustom01"
                                                                   min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                   value={currentDate}
                                                                   required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                                Activity Date
                                                            </label>
                                                        </div>
                                                        {reason.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <div className="col-sm-6 mt-1 float-field">
                                                                        <select
                                                                            className="form-control form-control-user"
                                                                            onChange={(e) => {
                                                                                handleReason(e.target.value, i, e)
                                                                            }}
                                                                            required
                                                                        >
                                                                            <option value="">Select Reason
                                                                            </option>
                                                                            <option value={"GET500 improvement"}>GET500
                                                                                improvement
                                                                            </option>
                                                                            <option
                                                                                value={"PPOP improvement"}>PPOP
                                                                                improvement
                                                                            </option>
                                                                            <option
                                                                                value={"For Issuance Growth"}>For
                                                                                Issuance Growth
                                                                            </option>
                                                                            <option
                                                                                value={"For Manpower Growth"}>For
                                                                                Manpower Growth
                                                                            </option>
                                                                            <option
                                                                                value={"Prepaid order"}>Prepaid order
                                                                            </option>
                                                                            <option
                                                                                value={"For Toll Permission"}>For Toll
                                                                                Permission
                                                                            </option>
                                                                            <option
                                                                                value={"Tags Distribution"}>Tags
                                                                                Distribution
                                                                            </option>
                                                                            <option
                                                                                value={"FSE"}>FSE Visit
                                                                            </option>
                                                                            <option
                                                                                value={"Others"}>Others
                                                                            </option>
                                                                        </select>
                                                                        <label className="large-label float-lb">
                                                                            Reason
                                                                        </label>
                                                                    </div>

                                                                    {/*{val?.reason === 'FSE' && FSE.map((val, i) => {*/}
                                                                    {/*    return (*/}
                                                                    {/*        <>*/}
                                                                    {/*            <div className="col-sm-6 mt-1 float-field">*/}
                                                                    {/*                <select*/}
                                                                    {/*                    className="form-control form-control-user"*/}
                                                                    {/*                    onChange={(e) => {*/}
                                                                    {/*                        handleFSE(e.target.value, i, e)*/}
                                                                    {/*                    }}*/}
                                                                    {/*                    required*/}
                                                                    {/*                >*/}
                                                                    {/*                    <option value="">Select FSE*/}
                                                                    {/*                    </option>*/}
                                                                    {/*                    {fseDetails?.data !== undefined && fseDetails?.data !== [] &&*/}
                                                                    {/*                        Object.keys(fseDetails?.data).length > 0 &&*/}
                                                                    {/*                        fseDetails?.data.map((fs, index) => {*/}
                                                                    {/*                            return (*/}
                                                                    {/*                                <>*/}
                                                                    {/*                                    <option value={`${fs.first_name+" ("+fs.user_phone+")"}`}>{`${fs.first_name+" ("+fs.user_phone+")"}`}*/}
                                                                    {/*                                    </option>*/}
                                                                    {/*                                </>*/}
                                                                    {/*                            )*/}
                                                                    {/*                        })*/}
                                                                    {/*                    }*/}

                                                                    {/*                </select>*/}
                                                                    {/*                <label className="large-label float-lb">*/}
                                                                    {/*                    FSE*/}
                                                                    {/*                </label>*/}
                                                                    {/*            </div>*/}

                                                                    {/*            <div className="btn-box mb-2">*/}
                                                                    {/*                {FSE.length !== 1 &&*/}
                                                                    {/*                    <>*/}
                                                                    {/*                        <button*/}
                                                                    {/*                            onClick={(e) => handleRemoveFSE(e, i)}*/}
                                                                    {/*                            className="btn btn-sm btn-info ml-3 btn-ar">Remove FSE*/}
                                                                    {/*                        </button>*/}
                                                                    {/*                    </>*/}
                                                                    {/*                }*/}
                                                                    {/*                {FSE.length - 1 === i &&*/}
                                                                    {/*                    <button type="button"*/}
                                                                    {/*                            className="btn btn-sm btn-success ml-3 btn-ar"*/}
                                                                    {/*                            onClick={() => handleAddFSE()}>Another FSE*/}
                                                                    {/*                    </button>}*/}
                                                                    {/*            </div>*/}
                                                                    {/*        </>*/}
                                                                    {/*    )*/}

                                                                    {/*})}*/}
                                                                    <div className="btn-box mb-2">
                                                                        {reason.length !== 1 &&
                                                                            <>
                                                                                <button
                                                                                    onClick={(e) => handleRemoveReason(e, i)}
                                                                                    className="btn btn-sm btn-danger ml-3 btn-ar">Remove
                                                                                    Reason
                                                                                </button>
                                                                            </>
                                                                        }
                                                                        {reason.length - 1 === i &&
                                                                            <button type="button"
                                                                                    className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                    onClick={() => handleAddReason()}>Another
                                                                                Reason
                                                                            </button>}
                                                                    </div>
                                                                </>
                                                            )
                                                        })
                                                        }
                                                        {/*<div className="col-sm-6 mtk-075 float-field mb-4">*/}
                                                        {/*    <DropDownInput*/}
                                                        {/*        data={senior}*/}
                                                        {/*        label={'Tagged Along'}*/}
                                                        {/*        getIdValue={(val) => {*/}
                                                        {/*            setTaggedAlonedReportee(val)*/}
                                                        {/*        }}*/}
                                                        {/*        multipule={true}*/}
                                                        {/*    />*/}
                                                        {/*</div>*/}
                                                        <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '', e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                                {/*Description*/}
                                                            </label>
                                                        </div>
                                                        {/*<div className="col-sm-12 mtk-1 float-field mb-3 d-mtk-2">*/}
                                                        {/*    <FileUpload*/}
                                                        {/*        id={"addAttachment"}*/}
                                                        {/*        accept=".png,.jpg,.jpeg"*/}
                                                        {/*        documentUploadUrl={documentUploadUrlPublic}*/}
                                                        {/*        documentUrlData={documentUrlDataPublic}*/}
                                                        {/*        onChange={(e, val) => {*/}
                                                        {/*            handleInput('meta_data', e, 'Document', e)*/}
                                                        {/*        }}*/}
                                                        {/*        prefilledFilename={""}*/}
                                                        {/*        multiple={true}*/}
                                                        {/*    >*/}
                                                        {/*        File Attachment*/}
                                                        {/*    </FileUpload>*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                            </div>
                                            {/*</div>*/}
                                            <div className="col-md-12 mt-4 d-flex">
                                                <button className="btn btn-primary btn-user btn-block submit-btn">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FastTagTollActivitySave

